<script setup>
import { ref } from 'vue';

defineProps({
  percentaje: {
    type: Number,
    default: 0
  },
  isFulled:{
    type: Boolean,
    default: false,
  }
  
});

const occupationColors = ref([
  {color: '#f56c6c', percentage: 70},
  {color: '#e6a23c', percentage: 80},
  {color: '#5cb87a', percentage: 100}
]);

const textColor = ref('#fff');
</script>

<template>
  <el-progress
      :stroke-width="20"
      :percentage="percentaje"
      :color="occupationColors"
      :text-inside="true"
      :text-color="textColor"
      :class="isFulled ? 'fullProgress-production' : ''"
  />
</template>

<style lang="scss" scoped>
.fullProgress-production::v-deep(.el-progress-bar__inner){
  width: 100% !important;
}
</style>